import type { ChainInfo } from '@safe-global/safe-gateway-typescript-sdk'
import { GATEWAY_URL } from '@/pages/_app'
import { APPCHAIN_CHAIN_ID, getAppchainChainInfo } from '@/config/appchain'

const GATEWAY_FETCH_TIMEOUT_MS = 2000

const withAppchain = (chains: ChainInfo[]): ChainInfo[] => {
  const appchain = getAppchainChainInfo()
  return [appchain, ...chains.filter((chain) => chain.chainId !== APPCHAIN_CHAIN_ID)]
}

const fetchGateway = async (url: string): Promise<Response> => {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), GATEWAY_FETCH_TIMEOUT_MS)

  try {
    return await fetch(url, { signal: controller.signal })
  } finally {
    clearTimeout(timeout)
  }
}

export const getConfigs = async (): Promise<ChainInfo[]> => {
  try {
    let allResults: ChainInfo[] = []
    let url: string | null = `${GATEWAY_URL}/v1/chains`

    while (url) {
      const response: Response = await fetchGateway(url)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data: { results?: ChainInfo[]; next?: string | null } = await response.json()
      const results = data.results || []
      allResults = allResults.concat(results)
      url = data.next || null
    }

    return withAppchain(allResults)
  } catch (error) {
    console.error('Failed to load chain configs from gateway, falling back to AppChain', error)
    return withAppchain([])
  }
}
